export type ViewMode = 'result' | 'source';

type Listener = (mode: ViewMode) => void;

export class ViewModeStore {
  private mode: ViewMode = 'result';
  private listeners: Listener[] = [];

  get(): ViewMode {
    return this.mode;
  }

  set(mode: ViewMode): void {
    if (this.mode === mode) return;
    this.mode = mode;
    for (const listener of this.listeners) listener(this.mode);
  }

  subscribe(listener: Listener): () => void {
    this.listeners.push(listener);
    listener(this.mode);
    return () => {
      this.listeners = this.listeners.filter((item) => item !== listener);
    };
  }
}

export function bindCanvasViewMode(
  source: HTMLCanvasElement,
  result: HTMLCanvasElement,
  store: ViewModeStore,
): void {
  store.subscribe((mode) => {
    source.style.visibility = mode === 'source' ? 'visible' : 'hidden';
    result.style.visibility = mode === 'result' ? 'visible' : 'hidden';
  });
}
